import { CSSObject } from 'styled-components';

const devices = {
  desktop: (css: CSSObject) => ({
    [`@media (hover: hover)`]: css,
  }),
  touchable: (css: CSSObject) => ({
    [`@media (hover: none)`]: css,
  }),
};

export default devices;
